import { useNavigate } from 'react-router-dom';

import EmptyProcessImage from '@/assets/svg/emptyProcess.svg?react';

const EmptyProcess = () => {
  const navigate = useNavigate();

  return (
    <div className="-translate-x-1/2 -translate-y-1/2 absolute top-[40%] left-1/2">
      <EmptyProcessImage opacity={0.5} />
      <h2 className="text-center text-muted-foreground text-xl">
        It's look empty here !
      </h2>
      <div className="flex w-full justify-center pt-4">
        <button
          className="relative overflow-hidden rounded-md px-5 py-2.5 font-medium text-sm shadow-sm transition-shadow hover:shadow-md"
          onClick={() => {
            navigate('/new');
          }}
          type="button"
        >
          <span className="-z-20 absolute inset-[-10rem] animate-spin bg-[conic-gradient(#fd004c,#fe9000,#fff020,#3edf4b,#3363ff,#b102b7)] [animation-duration:2s]" />
          <span className="-z-10 absolute inset-0.5 rounded-[3px] bg-white" />
          Create your first project
        </button>
      </div>
    </div>
  );
};

export default EmptyProcess;
